import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const ModeChanger = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <div className="mode-changer-wrapper">
        <div className="mode-changer">
          <div className="complaint-mode-on">
            <NavLink exact activeClassName="selected" to="/requests">{t("lodgeAComplaint")}</NavLink>
          </div>
          <div className="help-mode-on">
            <NavLink activeClassName="selected" to="/requests/help">{t("help")}</NavLink>
          </div>
          <div className="mode-pointer-wrapper">
            <div id="progress" className="progress-pointer"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModeChanger;
